







































import { defineComponent } from "@vue/composition-api";
import { emailAddress, urls } from "~/constants";

export default defineComponent({
  name: "Footer",

  props: {},

  setup() {
    const socialLinks = [
      {
        text: "Github",
        attributes: {
          href: urls.githubProfile,
        },
      },
      {
        text: "LinkedIn",
        attributes: {
          href: urls.linkedInProfile,
        },
      },
      {
        text: "Twitter",
        attributes: {
          href: urls.twitterProfile,
        },
      },
      {
        text: "Blog",
        attributes: {
          href: urls.blogUrl,
        },
      },
      {
        text: "Instagram",
        attributes: {
          href: urls.instagramProfile,
        },
      },
    ];

    return {
      emailAddress,
      socialLinks,
      urls,
    };
  },
});
